import { render, staticRenderFns } from "./walletEdit.vue?vue&type=template&id=271d8444&scoped=true"
import script from "./walletEdit.vue?vue&type=script&lang=js"
export * from "./walletEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d8444",
  null
  
)

export default component.exports